<template>
  <div class="relative border-b border-white/10 bg-slate-900/80 backdrop-blur-2xl">
    <div class="absolute inset-0 bg-gradient-to-r from-amber-500/5 via-pink-500/5 to-transparent"></div>

    <div
        class="relative mx-auto max-w-7xl py-4 px-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
    >
      <div class="flex items-center gap-4 pt-2">
        <div class="relative">
          <div class="w-14 h-14 rounded-2xl bg-slate-900/80 backdrop-blur-xl border border-amber-400/30
                 flex items-center justify-center shadow-2xl shadow-amber-500/20 overflow-hidden">
            <img
                v-if="currentUser && currentUser.profile_picture"
                :src="img_source(currentUser.profile_picture)"
                :alt="currentUser.username"
                class="w-full h-full object-cover"
            >
            <div
                v-else
                class="w-full h-full bg-gradient-to-br from-amber-500 to-pink-600 flex items-center justify-center"
            >
              <span class="text-lg font-black text-white">👤</span>
            </div>
          </div>

          <div class="absolute -bottom-1 -right-1 w-5 h-5 bg-emerald-500 rounded-full border-2 border-slate-900
                 flex items-center justify-center shadow-lg shadow-emerald-500/50">
            <div class="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
          </div>

          <div class="absolute -inset-2 rounded-2xl bg-amber-400/10 blur-md opacity-60"></div>
        </div>

        <div class="text-right">
          <h1 class="text-xl font-bold text-slate-50 drop-shadow-lg flex items-center gap-2">
            فروشگاه
            <span class="text-amber-300">EXUNI</span>
          </h1>

          <p class="text-sm text-slate-300/80 mt-1 font-light">
            {{ currentUser && currentUser.username ? currentUser.username : 'کاربر' }} - ادمین {{ title }}
            <span
                class="text-xs px-2 py-1 bg-emerald-500/20 text-emerald-300 rounded-lg border border-emerald-400/30">
              آنلاین
            </span>
          </p>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosDashboardHeader',

  props: {
    currentUser: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: ''
    },
    imgSource: {
      type: Function,
      required: true
    }
  }
}
</script>